import React, { useState, useEffect } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { orderBy } from 'natural-orderby';

import ItemCard from '../../../components/Rewards/ItemCard';
import { newFetch, GET } from '../../../helpers/fetch';
import moment from 'moment';
import SpringLoader from '../../../components/SpringLoader/SpringLoader.js';

const Rewards = ({ history }) => {
  const [rewards, setRewards] = useState([]);
  const [sortedRewards, setSortedRewards] = useState([]);
  const [showInactive, setShowInactive] = useState(false);
  const [loading, setLoading] = useState(true);

  const sortOptions = [
    'Release Date',
    'Item Name',
    'Points Required',
    'Items Redeemed',
    'Item Left',
  ];

  const [activeSort, setActiveSort] = useState('Release Date');

  const fetchRewards = async () => {
    setLoading(true);
    let api_path = `/reward`;
    let response = await newFetch(GET, api_path);

    response.success && setRewards(response.results);
    setLoading(false);
  };

  useEffect(() => {
    fetchRewards();
  }, []);

  useEffect(() => {
    if (activeSort === 'Item Name') {
      let sorted = orderBy(rewards, [(item) => item.name]);
      setSortedRewards(sorted);
    }
    if (activeSort === 'Points Required') {
      let sorted = orderBy(rewards, [
        (item) => item.redeem_points,
        (item) => item.name,
      ]);
      setSortedRewards(sorted);
    }
    if (activeSort === 'Items Redeemed') {
      let sorted = orderBy(rewards, [
        (item) =>
          item.redeemed.reduce((total, redeem) => total + redeem.quantity, 0),
      ]);
      setSortedRewards(sorted);
    }
    if (activeSort === 'Item Left') {
      let sorted = orderBy(rewards, [
        (item) => {
          let total = item.redeemed.reduce(
            (total, redeem) => total + redeem.quantity,
            0
          );

          return item.quantity - total;
        },
      ]);

      setSortedRewards(sorted);
    }

    if (activeSort === 'Release Date') {
      let sorted = rewards.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );

      setSortedRewards(sorted);
    }
  }, [rewards, activeSort]);
  return (
    <div
      className="container-fluid"
      style={{ paddingLeft: '2rem', paddingRight: '2rem' }}
    >
      <div className="border-bottom pb-2 py-2 d-flex align-items-center">
        <h6 className="flex-grow-1 pt-4" style={{ color: '#5156BE' }}>
          Rewards Item Management
        </h6>
        <div className="form-check">
          <input
            className="form-check-input me-2 mt-2"
            type="checkbox"
            name="hideInactiveCheck"
            id="hideInactiveCheck"
            value={showInactive}
            onChange={() => setShowInactive(!showInactive)}
          />
          <label className="form-check-label mt-2" htmlFor="hideInactiveCheck">
            Show Inactive?
          </label>
        </div>
        <NavLink
          to="/rewards/add"
          className="text-decoration-none"
          style={{ color: 'inherit' }}
        >
          <button
            className="btn btn-outline-brand ms-3 mt-2 adjust-fs adjust-shadow"
            style={{ width: '200px' }}
          >
            Add New
          </button>
        </NavLink>
      </div>
      <div className="d-flex flex-row align-items-center justify-content-between py-3">
        <h6 className="flex-grow-1">
          Rewards (
          {showInactive
            ? sortedRewards.length
            : sortedRewards.filter((reward) => reward.active).length}
          )
        </h6>
        <div className="d-flex align-items-center">
          <div className="pe-2">Sort By:</div>
          <select
            id="sortRewards"
            className="form-select adjust-fs rounded-1"
            style={{ width: '200px' }}
            onChange={({ target: { value } }) => setActiveSort(value)}
          >
            {sortOptions.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="d-flex flex-row align-items-center justify-content-center mb-3">
        <div className="row w-100">
          {!loading ? (
            showInactive ? (
              sortedRewards.map((item, index) => (
                <div
                  key={index}
                  className="col-md-2 col-sm-6 pb-4"
                  style={{ cursor: 'pointer' }}
                  onClick={() => history.push(`/rewards/item/${item.id}`)}
                >
                  <ItemCard item={item} />
                </div>
              ))
            ) : (
              sortedRewards
                .filter((reward) => reward.active)
                .map((item, index) => (
                  <div
                    key={index}
                    className="col-md-2 col-sm-6 pb-4"
                    style={{ cursor: 'pointer' }}
                    onClick={() => history.push(`/rewards/item/${item.id}`)}
                  >
                    <ItemCard item={item} />
                  </div>
                ))
            )
          ) : (
            <div
              className="springloader-holder"
              style={{ position: 'relative' }}
            >
              <SpringLoader></SpringLoader>
            </div>
          )}

          {!loading && sortedRewards.length == 0 && (
            <div className="springloader-holder" style={{ height: 200 }}>
              <span>No record found.</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default withRouter(Rewards);
